import { Action } from "@reduxjs/toolkit";
import { ClientState } from "./types";
import { isType } from "typescript-fsa";
import { clientActions } from "./actions";

const initialState: ClientState = {
    total_items: 0,
    total_pages: 0,
    current_page: 1,
    page_size: 10,
    next_page: null,
    previous_page: null,
    clients: [],
    selectedClient: null
}

export function ClientReducer(state = initialState, action: Action): ClientState {
    if (isType(action, clientActions.fetchClients.done)) {
        const data = action.payload.result
        return {
            ...state,
            total_items: data.total_items,
            total_pages: data.total_pages,
            current_page: data.current_page,
            page_size: data.page_size,
            next_page: data.next_page,
            previous_page: data.previous_page,
            clients: data.data.map((client) => ({
                id: client.id,
                inquiry_number: client.inquiry_number,
                inquiry_type: client.inquiry_type,
                role: client.role,
                last_name: client.last_name,
                first_name: client.first_name,
                username: client.username,
                phone_number: client.phone_number,
                email_address: client.email_address,
                description: client.description,
                read: client.read,
                created_at: client.created_at,
            })),
        }
    }
    if (isType(action, clientActions.getClientDetails.done)) {
        return {
            ...state,
            selectedClient: action.payload.result,
        };
    }
    if (isType(action, clientActions.updateClientReadStatus.done)) {
        const { id, read } = action.payload.params;
        return {
            ...state,
            clients: state.clients.map(client => 
                client.id === id ? { ...client, read } : client
            ),
        };
    }
    if (isType(action, clientActions.resetToInitialState)) {
        return initialState;
    }

    return state;
}